import { managerInstance } from "libs/api";
import { DeliveryCompany } from "modules/deliveryCompanies";

import { ApiRoutesCompanyAdminAuth } from "../../constants";

export const requestGetCurrentManager = async (): Promise<DeliveryCompany> => {
  return await managerInstance.get(ApiRoutesCompanyAdminAuth.Me);
};
